import { useMediaQuery } from '@mantine/hooks';
import { Notifications } from '@mantine/notifications';

import classes from './notifications.module.css';

export const AppNotifications = () => {
  const mobile = useMediaQuery('(max-width: 35.99em)', false, { getInitialValueInEffect: false });
  return (
    <Notifications
      position={mobile ? 'top-center' : 'bottom-right'}
      containerWidth="26rem"
      limit={4}
      classNames={{ root: classes.container, notification: classes.notification }}
    />
  );
};
